module.exports = __webpack_public_path__ + "img/commerce_and_living.6dedca0e.svg";